import { useState, useEffect, useCallback, useRef } from "react";
import {
  currencyFormate,
  formatInputToCapitalization,
  removeCurrencyComma,
  getInvalidFromDate,
} from "../Date_Formate_Utilitiy/Index";
import { flushSync } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { openModal, closeModal } from "../../redux/actions/action-creator";
import React from "react";
import { toast } from "react-toastify";
import { parseTallyQuantity, formatTallyQuantity, formatQuantityWithUnit, parseUnitString, calculateAltUnits, calculateBaseUnitsFromInput, calculateUnitsDivisor } from "../Date_Formate_Utilitiy/StockItemUtility";

export const useInputActionStockItem = ({
  initialState,
  validations,
  dynamicValidations,
  refs,
  check_dropdown,
  inputRefs,
  dynamicInputRef,
  dynamicFieldRefs,
  nameInput,
  setNameInput,
}) => {
  const [submitConfirm, setSubmitConfirm] = useState("");
  const [data, setData] = useState(initialState);
  const dispatch = useDispatch();
  const { godown_data = null, company_session, unit_data = null } = useSelector((state) => state.common);
  const modal_state = useSelector((state) => state.common.modal_state);

  const getDecimalPlaces = useCallback((unitSymbol) => {
    if (!unitSymbol || unitSymbol === "Not Applicable" || !unit_data) return 0;

    const unitInfo = parseUnitString(unitSymbol);
    if (unitInfo && unitInfo.type === 'Compound') {
      // For compound units, we follow the base unit's decimal places for the remainder
      const baseUnit = unit_data.find(u => u.symbol === unitInfo.baseUnit);
      return baseUnit ? parseInt(baseUnit.no_decimal_places) || 0 : 0;
    }

    const unit = unit_data.find(u => u.symbol === unitSymbol);
    return unit ? parseInt(unit.no_decimal_places) || 0 : 0;
  }, [unit_data]);

  const handleItemUpdate = (e, index, key, value) => {
    const cleanString = (str) => str.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();

    const cleanNumberInput = (value) => {
      // Remove all commas
      let cleanedValue = value.replace(/,/g, "");

      // Allow only first decimal point and remove extras
      const parts = cleanedValue.split(".");
      if (parts.length > 1) {
        cleanedValue = parts.shift() + "." + parts.join(""); // Keep first dot, merge remaining decimals
      }

      return cleanedValue;
    };

    switch (key) {
      case "godown_name":
        const godownListToVerify = [{ name: "End of List" }, { name: "Any" }, ...(godown_data || [])];
        const value_ = godownListToVerify?.some((item) =>
          cleanString(item.name)?.includes(cleanString(value))
        );
        if (value_) {
          setData((prevState) => ({
            ...prevState,
            data_item: prevState.data_item.map((item, i) => {
              if (i === index) {
                const updatedItem = { ...item, [key]: value };
                return updatedItem;
              }
              return item;
            }),
          }));
        }
        break;
      case "quantity":
      case "rate":
      case "per":
        if (key === "per" || key === "quantity" || /^[0-9,.\- \b]*$/.test(value) || value === "") {
          setData((prevState) => {
            const unitInfo = parseUnitString(prevState.unit_name);
            const mainUnitFactor = unitInfo?.factor || 1;
            const isCompound = mainUnitFactor > 1;

            const updatedDataItems = prevState.data_item.map((item, i) => {
              if (i === index) {
                const updatedItem = { ...item, [key]: value };

                // Calculation logic
                const totalBaseUnits = parseTallyQuantity(updatedItem.quantity?.split(' ')[0], mainUnitFactor, isCompound);
                const rateNum = parseFloat(removeCurrencyComma(updatedItem.rate)) || 0;
                const perUnit = updatedItem.per || "";
                let divisor = 1;
                const altUnitInfo = parseUnitString(prevState.alt_unit_name);
                divisor = calculateUnitsDivisor(prevState, unitInfo, altUnitInfo, perUnit);

                const precision = getDecimalPlaces(prevState.unit_name);
                if (key === "quantity") {
                  if (value.includes('.') && precision === 0) {
                    return item; // Block decimal if precision is 0
                  }
                  if (value.includes('.')) {
                    const parts = value.split('.');
                    if (parts[1].length > precision) {
                      return item; // Block if exceeds precision
                    }
                  }
                }

                //const totalAltUnits = calculateAltUnits(totalBaseUnits, prevState);
                const totalAltUnits = calculateAltUnits(totalBaseUnits, prevState);
                const altPrecision = getDecimalPlaces(prevState?.alt_unit_name);
                const alt_unit_label = prevState?.alt_unit_name || "";
                let formattedAltQty = "";
                if (altUnitInfo && altUnitInfo.type === 'Compound') {
                  formattedAltQty = formatTallyQuantity(totalAltUnits, altUnitInfo.factor, altPrecision, altUnitInfo);
                } else {
                  formattedAltQty = formatTallyQuantity(totalAltUnits, 1, altPrecision, altUnitInfo);
                }

                updatedItem.combination_of_units = (alt_unit_label && alt_unit_label !== "Not Applicable")
                  ? `${formattedAltQty}`
                  : "";

                updatedItem.value = currencyFormate(((totalBaseUnits / divisor) * rateNum).toFixed(2));
                return updatedItem;
              }
              return item;
            });

            const totalQuantity = updatedDataItems.reduce((sum, item) => {
              return sum + (parseTallyQuantity(item.quantity?.split(' ')[0], mainUnitFactor, isCompound) || 0);
            }, 0);

            const totalAmount = updatedDataItems.reduce((sum, item) => {
              return sum + (parseFloat(removeCurrencyComma(item.value)) || 0);
            }, 0);

            return {
              ...prevState,
              data_item: updatedDataItems,
              total_quantitiy_allocation: totalQuantity,
              total_amount_allocation: totalAmount,
            };
          });
        }
        break;
      case "value":
        if (/^[0-9,.\b]*$/.test(value) || value === "") {
          setData((prevState) => {
            const unitInfo = parseUnitString(prevState.unit_name);
            const mainUnitFactor = unitInfo?.factor || 1;
            const isCompound = mainUnitFactor > 1;

            const updatedDataItems = prevState.data_item.map((item, i) => {
              if (i === index) {
                const updatedItem = { ...item, [key]: value };
                const totalBaseUnits = parseTallyQuantity(updatedItem.quantity?.split(' ')[0], mainUnitFactor, isCompound);
                const valNum = parseFloat(removeCurrencyComma(value)) || 0;
                const perUnit = updatedItem.per || "";

                let divisor = 1;
                const altUnitInfo = parseUnitString(prevState.alt_unit_name);
                divisor = calculateUnitsDivisor(prevState, unitInfo, altUnitInfo, perUnit);
                const calculatedRate = (totalBaseUnits !== 0) ? (valNum / (totalBaseUnits / divisor)) : 0;
                updatedItem.rate = currencyFormate(calculatedRate.toFixed(2));
                updatedItem.value = currencyFormate(valNum.toFixed(2));
                return updatedItem;
              }
              return item;
            });

            const totalQuantity = updatedDataItems.reduce((sum, item) => {
              return sum + (parseTallyQuantity(item.quantity?.split(' ')[0], mainUnitFactor, isCompound) || 0);
            }, 0);

            const totalAmount = updatedDataItems.reduce((sum, item) => {
              return sum + (parseFloat(removeCurrencyComma(item.value)) || 0);
            }, 0);

            return {
              ...prevState,
              data_item: updatedDataItems,
              total_quantitiy_allocation: totalQuantity,
              total_amount_allocation: totalAmount,
            };
          });
        }
        break;
      default:
        setData((prevState) => ({
          ...prevState,
          data_item: prevState.data_item.map((item, i) => {
            if (i === index) {
              const updatedItem = { ...item, [key]: value };
              return updatedItem;
            }
            return item;
          }),
        }));
    }

    // Calculate total amount from all rows

    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  // Handle dynamic inputs
  const handleDynamicFocus = (e, index, field) => {
    // Get the reference key for the current field
    const refKey = `${field}${index} `;
    // Get the input reference
    const ref = dynamicInputRef.current[refKey];
    if (ref) {
      setNameInput(ref);
      ref.setSelectionRange(0, ref.value?.length || 0);
    }

    // Handle modal opening for specific fields
    if (field === "godown_name") {
      dispatch(openModal(refKey));
    }
    if (field === "per") {
      dispatch(openModal(refKey));
    }
  };

  const handleDynamicBlur = (e, index, field) => {
    // Get the reference key for the current field
    const refKey = `${field}${index} `;

    // Handle modal closing for specific fields
    if (field === "godown_name") {
      dispatch(closeModal(refKey));
    }
    if (field === "per") {
      dispatch(closeModal(refKey));
    }

    if (field === "quantity" || field === "rate" || field === "value") {
      setData((prevState) => {
        let updatedDataItems = [...prevState.data_item];
        let item = { ...updatedDataItems[index] };
        const value = e.target.value;

        const unitInfo = parseUnitString(prevState.unit_name);
        const mainUnitFactor = unitInfo?.factor || 1;
        const isCompound = mainUnitFactor > 1;
        const precision = getDecimalPlaces(prevState.unit_name);

        let inputBaseUnits = 0;
        if (field === "quantity") {
          inputBaseUnits = calculateBaseUnitsFromInput(value, prevState);
        } else {
          inputBaseUnits = calculateBaseUnitsFromInput(item.quantity?.split(' ')[0], prevState);
        }

        if (field === "quantity" && value !== "" && inputBaseUnits === 0) {
          item.quantity = "";
          item.rate = "";
          item.value = "";
          item.per = "";
          item.combination_of_units = "";
        } else {
          const quantityLabel = unitInfo?.mainUnit || prevState?.unit_name || "";
          item.quantity = formatQuantityWithUnit(inputBaseUnits, mainUnitFactor, quantityLabel, precision, unitInfo);
          if (field !== "quantity" || value === "") {
            item[field] = value;
          }

          const totalAltUnits = calculateAltUnits(inputBaseUnits, prevState);
          const altPrecision = getDecimalPlaces(prevState?.alt_unit_name);
          const altUnitInfo = parseUnitString(prevState.alt_unit_name);
          let formattedAltQty = "";
          if (altUnitInfo && altUnitInfo.type === 'Compound') {
            formattedAltQty = formatTallyQuantity(totalAltUnits, altUnitInfo.factor, altPrecision, altUnitInfo);
          } else {
            formattedAltQty = formatTallyQuantity(totalAltUnits, 1, altPrecision, altUnitInfo);
          }
          item.combination_of_units = (prevState?.alt_unit_name && prevState?.alt_unit_name !== "Not Applicable") ? `${formattedAltQty}` : "";

          if (field === "value") {
            const valNum = parseFloat(removeCurrencyComma(value)) || 0;
            const perUnit = item.per || "";
            let divisor = calculateUnitsDivisor(prevState, unitInfo, altUnitInfo, perUnit);
            const calculatedRate = (inputBaseUnits !== 0) ? (valNum / (inputBaseUnits / divisor)) : 0;
            item.rate = currencyFormate(calculatedRate.toFixed(2));
            item.value = currencyFormate(valNum.toFixed(2));
          } else {
            const rateNum = parseFloat(removeCurrencyComma(item.rate)) || 0;
            const perUnit = item.per || "";
            let divisor = calculateUnitsDivisor(prevState, unitInfo, altUnitInfo, perUnit);
            item.value = currencyFormate(((inputBaseUnits / divisor) * rateNum).toFixed(2));
          }
        }

        updatedDataItems[index] = item;

        const totalQuantity = updatedDataItems.reduce(
          (sum, it) => sum + (parseTallyQuantity(it.quantity?.split(' ')[0], mainUnitFactor, isCompound) || 0),
          0
        );

        const totalAmount = updatedDataItems.reduce(
          (sum, it) => sum + (parseFloat(removeCurrencyComma(it.value)) || 0),
          0
        );

        return {
          ...prevState,
          data_item: updatedDataItems,
          total_quantitiy_allocation: totalQuantity,
          total_amount_allocation: totalAmount,
        };
      });
    }
  };

  const handleKeyDownItem = (e, index, key) => {
    const value = e.target.value;
    if (e.key === "Enter" || (e.key === "Tab" && !e.shiftKey)) {
      e.preventDefault(); // Prevent form submission
      e.stopPropagation(); // Prevent reaching background components
      const unitInfo = parseUnitString(data.unit_name);
      const mainUnitFactor = unitInfo?.factor || 1;
      const isCompound = mainUnitFactor > 1;
      const precision = getDecimalPlaces(data.unit_name);
      const targetQuantity = parseTallyQuantity(data?.quantity?.split(' ')[0], mainUnitFactor, isCompound) || 0;
      const targetValue = parseFloat(removeCurrencyComma(data?.value)) || 0;

      if (key === "quantity") {
        // We will update the quantity via updatedDataItems to avoid double state updates
      }

      const fields = ["godown_name", "quantity", "rate", "per", "value"];
      const currentFieldIndex = fields.indexOf(key);
      let updatedDataItems = [];
      let currentRunningQuantity = 0;
      let stopProcessing = false;

      for (let i = 0; i < data.data_item.length; i++) {
        if (stopProcessing) break;

        let item = { ...data.data_item[i] };
        let itemQty = 0;

        if (i < index) {
          // Rows before the current row
          itemQty = parseTallyQuantity(item.quantity?.split(' ')[0], mainUnitFactor, isCompound) || 0;
          updatedDataItems.push(item);
        } else if (i === index) {
          // The row currently being edited
          let inputBaseUnits = 0;
          if (key === "quantity") {
            inputBaseUnits = calculateBaseUnitsFromInput(value, data);
          } else {
            inputBaseUnits = calculateBaseUnitsFromInput(item.quantity?.split(' ')[0], data);
          }

          const remainingAvailable = Math.max(0, targetQuantity - currentRunningQuantity);

          if (inputBaseUnits >= remainingAvailable && targetQuantity > 0) {
            itemQty = remainingAvailable;
            stopProcessing = true; // Any rows below this should be removed
          } else {
            itemQty = inputBaseUnits;
          }

          if (key === "quantity" && value !== "" && inputBaseUnits === 0) {
            item.quantity = "";
            item.rate = "";
            item.value = "";
            item.per = "";
            item.combination_of_units = "";
          } else {
            // Update item fields for the current row
            const quantityLabel = unitInfo?.mainUnit || data?.unit_name || "";
            item.quantity = formatQuantityWithUnit(itemQty, mainUnitFactor, quantityLabel, precision, unitInfo);

            // Update the specific field being edited
            if (key !== "quantity" || value === "") {
              item[key] = value;
            }

            // Recalculate other fields (Alt Units, Rate/Value)
            const totalAltUnits = calculateAltUnits(itemQty, data);
            const alt_unit_label = data?.alt_unit_name || "";
            const altPrecision = getDecimalPlaces(data?.alt_unit_name);
            const altUnitInfo = parseUnitString(data.alt_unit_name);
            let formattedAltQty = "";
            if (altUnitInfo && altUnitInfo.type === 'Compound') {
              formattedAltQty = formatTallyQuantity(totalAltUnits, altUnitInfo.factor, altPrecision, altUnitInfo);
            } else {
              formattedAltQty = formatTallyQuantity(totalAltUnits, 1, altPrecision, altUnitInfo);
            }
            item.combination_of_units = (alt_unit_label && alt_unit_label !== "Not Applicable") ? `${formattedAltQty}` : "";

            if (key === "value") {
              // In value mode, we update rate based on value and quantity
              const valNum = parseFloat(removeCurrencyComma(value)) || 0;
              const perUnit = item.per || "";
              let divisor = calculateUnitsDivisor(data, unitInfo, altUnitInfo, perUnit);
              const calculatedRate = (itemQty !== 0) ? (valNum / (itemQty / divisor)) : 0;
              item.rate = currencyFormate(calculatedRate.toFixed(2));
              item.value = currencyFormate(valNum.toFixed(2));
            } else {
              // Normal mode: update value based on rate and quantity
              const rateNum = parseFloat(removeCurrencyComma(item.rate)) || 0;
              const perUnit = item.per || "";
              let divisor = calculateUnitsDivisor(data, unitInfo, altUnitInfo, perUnit);
              item.value = currencyFormate(((itemQty / divisor) * rateNum).toFixed(2));
            }
          }

          updatedDataItems.push(item);
        } else {
          // Rows after the current row
          const remainingAvailable = Math.max(0, targetQuantity - currentRunningQuantity);
          itemQty = parseTallyQuantity(item.quantity?.split(' ')[0], mainUnitFactor, isCompound) || 0;

          if (currentRunningQuantity + itemQty >= targetQuantity && targetQuantity > 0) {
            itemQty = remainingAvailable;
            if (itemQty > 0) {
              // Adjust this row to fill the balance and then stop
              const quantityLabel = unitInfo?.mainUnit || data?.unit_name || "";
              item.quantity = formatQuantityWithUnit(itemQty, mainUnitFactor, quantityLabel, precision, unitInfo);

              const totalAltUnits = calculateAltUnits(itemQty, data);
              const altPrecision = getDecimalPlaces(data?.alt_unit_name);
              const altUnitInfo = parseUnitString(data.alt_unit_name);
              let formattedAltQty = "";
              if (altUnitInfo && altUnitInfo.type === 'Compound') {
                formattedAltQty = formatTallyQuantity(totalAltUnits, altUnitInfo.factor, altPrecision, altUnitInfo);
              } else {
                formattedAltQty = formatTallyQuantity(totalAltUnits, 1, altPrecision, altUnitInfo);
              }
              item.combination_of_units = (data?.alt_unit_name && data?.alt_unit_name !== "Not Applicable") ? `${formattedAltQty}` : "";

              const rateNum = parseFloat(removeCurrencyComma(item.rate)) || 0;
              const perUnit = item.per || "";
              let divisor = calculateUnitsDivisor(data, unitInfo, altUnitInfo, perUnit);
              item.value = currencyFormate(((itemQty / divisor) * rateNum).toFixed(2));

              updatedDataItems.push(item);
            }
            stopProcessing = true; // Remove any further rows
          } else {
            updatedDataItems.push(item);
          }
        }
        currentRunningQuantity += itemQty;
      }

      const totalQuantity = updatedDataItems.reduce(
        (sum, item) => {
          const unitInfo = parseUnitString(data.unit_name);
          const mainUnitFactor = unitInfo?.factor || 1;
          const isCompound = mainUnitFactor > 1;
          return sum + (parseTallyQuantity(item.quantity?.split(' ')[0], mainUnitFactor, isCompound) || 0);
        },
        0
      );

      const totalAmount = updatedDataItems.reduce(
        (sum, item) =>
          sum + (parseFloat(removeCurrencyComma(item.value)) || 0),
        0
      );

      const quantityLabelForHeader = unitInfo?.mainUnit || data?.unit_name || "";
      const precisionForHeader = getDecimalPlaces(data?.unit_name);
      const formattedQty = formatQuantityWithUnit(totalQuantity, mainUnitFactor, quantityLabelForHeader, precisionForHeader, unitInfo);

      setData((prevState) => ({
        ...prevState,
        data_item: updatedDataItems,
        total_quantitiy_allocation: totalQuantity,
        total_amount_allocation: totalAmount,
      }));

      if (currentFieldIndex < fields.length - 1) {
        let nextFieldKey = fields[currentFieldIndex + 1];
        // Skip quantity, rate, per if unit_name is Not Applicable (only for by_value modal)
        if (data?.unit_name === "Not Applicable" && key === "godown_name") {
          nextFieldKey = "value";
        }

        const nextRef = dynamicInputRef.current[`${nextFieldKey}${index} `];
        if (nextRef) {
          nextRef.focus();
          nextRef.setSelectionRange(0, nextRef.value?.length || 0);
        }
      } else {
        if (index < updatedDataItems.length - 1) {
          const nextRowRef = dynamicInputRef.current[`godown_name${index + 1} `];
          if (nextRowRef) {
            nextRowRef.focus();
            nextRowRef.setSelectionRange(0, nextRowRef.value?.length || 0);
          }
        } else {
          if (data?.modal_type === "by_qty") {
            if (totalQuantity < targetQuantity) {
              addRow(index + 1);
            } else {
              // totalQuantity >= targetQuantity: Trigger Accept logic
              setData((prevState) => {
                const latestTotalQuantity = prevState?.data_item?.reduce(
                  (sum, item) => {
                    return sum + (parseTallyQuantity(item.quantity?.split(' ')[0], mainUnitFactor, isCompound) || 0);
                  },
                  0
                );
                const latestTotalAmount = prevState?.data_item?.reduce(
                  (sum, item) => sum + (parseFloat(removeCurrencyComma(item.value)) || 0),
                  0
                );
                const finalPer = unitInfo?.mainUnit || data?.unit_name || "";
                const getRate = latestTotalQuantity !== 0 ? latestTotalAmount / (latestTotalQuantity / mainUnitFactor) : 0;
                return {
                  ...prevState,
                  quantity: formattedQty,
                  rate: currencyFormate(getRate.toFixed(2)),
                  per: finalPer,
                  value: currencyFormate(latestTotalAmount.toFixed(2)),
                };
              });

              dispatch(closeModal("itemwithgodown"));
              setSubmitConfirm("Accept");
            }
          } else {
            if (totalAmount < targetValue) {
              addRow(index + 1);
            } else {
              // totalAmount >= targetValue: Trigger Accept logic
              setData((prevState) => {
                const latestTotalQuantity = prevState?.data_item?.reduce(
                  (sum, item) => {
                    return sum + (parseTallyQuantity(item.quantity?.split(' ')[0], mainUnitFactor, isCompound) || 0);
                  },
                  0
                );
                const latestTotalAmount = prevState?.data_item?.reduce(
                  (sum, item) => sum + (parseFloat(removeCurrencyComma(item.value)) || 0),
                  0
                );
                const finalPer = unitInfo?.mainUnit || data?.unit_name || "";
                const getRate = latestTotalQuantity !== 0 ? latestTotalAmount / (latestTotalQuantity / mainUnitFactor) : 0;
                return {
                  ...prevState,
                  quantity: formattedQty,
                  rate: currencyFormate(getRate.toFixed(2)),
                  per: finalPer,
                  value: currencyFormate(latestTotalAmount.toFixed(2)),
                };
              });

              dispatch(closeModal("itemwithgodown"));
              setSubmitConfirm("Accept");
            }
          }
        }
      }
      return;
    }

    if (e.key === "Tab" && e.shiftKey) {
      e.preventDefault();
      e.stopPropagation(); // Prevent reaching background components
      setSubmitConfirm("");
      const fields = ["godown_name", "quantity", "rate", "per", "value"];
      const currentFieldIndex = fields.indexOf(key);

      if (currentFieldIndex > 0) {
        let prevFieldKey = fields[currentFieldIndex - 1];

        // Skip per, rate, quantity if unit_name is Not Applicable
        if (data?.unit_name === "Not Applicable" && key === "value") {
          prevFieldKey = "godown_name";
        }

        const prevRef = dynamicInputRef.current[`${prevFieldKey}${index} `];
        if (prevRef) {
          prevRef.focus();
          prevRef.setSelectionRange(0, prevRef.value?.length || 0);
        }
      } else if (index > 0) {
        const lastFieldInPrevRow = data?.unit_name === "Not Applicable" ? "value" : "value"; // Actually both modes end with value
        const prevRowRef = dynamicInputRef.current[`value${index - 1} `];
        if (prevRowRef) {
          prevRowRef.focus();
          prevRowRef.setSelectionRange(0, prevRowRef.value?.length || 0);
        }
      }
    }
  };

  const addRow = (nextIndex) => {
    setData((prevState) => {
      const unitInfo = parseUnitString(prevState.unit_name);
      const mainUnitFactor = unitInfo?.factor || 1;
      const isCompound = mainUnitFactor > 1;

      const targetQuantity = parseTallyQuantity(prevState?.quantity?.split(' ')[0], mainUnitFactor, isCompound) || 0;
      const targetValue = parseFloat(removeCurrencyComma(prevState?.value)) || 0;

      const currentTotalQuantity = prevState.data_item.reduce((sum, item) => {
        return sum + (parseTallyQuantity(item.quantity?.split(' ')[0], mainUnitFactor, isCompound) || 0);
      }, 0);

      const currentTotalValue = prevState.data_item.reduce((sum, item) => {
        return sum + (parseFloat(removeCurrencyComma(item.value)) || 0);
      }, 0);

      const remainingQuantity = Math.max(0, targetQuantity - currentTotalQuantity);
      const remainingValue = Math.max(0, targetValue - currentTotalValue);

      const newRow = {
        id: (nextIndex + 1).toString(),
        godown_name: "",
        location: "",
        quantity: remainingQuantity > 0 ? formatQuantityWithUnit(remainingQuantity, mainUnitFactor, unitInfo?.mainUnit || prevState?.unit_name, getDecimalPlaces(prevState?.unit_name), unitInfo) : "",
        combination_of_units: "",
        rate: "",
        per: prevState?.unit_name,
        value: remainingValue > 0 ? currencyFormate(remainingValue.toFixed(2)) : "",
        total_nos_box: "",
        total_no_box_unit: prevState?.alt_unit_name,
      };

      return {
        ...prevState,
        data_item: [...prevState.data_item, newRow],
      };
    });

    setTimeout(() => {
      dynamicInputRef.current[`godown_name${nextIndex} `]?.focus();
    }, 50);
  };

  const handleChange = (e, index) => {
    let { name, value } = e.target;
    if (e.code === "Space") {
      const cursorPosition = e.target.selectionStart;
      if (cursorPosition === 1) {
        setData({ ...data, [name]: "" });
        return;
      }
    }

    // Apply field-specific validations
    const validation = validations[name];
    if (validation) {
      const isValid = validation(value);
      if (isValid || value === "") {
        setData((prevData) => {
          const updatedData = { ...prevData };

          if (typeof index !== "number") {
            const updatedValue =
              name === "name" || name === "notes"
                ? formatInputToCapitalization(value)
                : value;
            updatedData[name] = updatedValue;
          } else if (typeof index === "number") {
            // Update array fields within `data_item`
            updatedData.data_item = updatedData.data_item.map((item, i) =>
              i === index ? { ...item, [name]: value } : item
            );
          }

          if (name === "quantity") {
            const precision = getDecimalPlaces(updatedData.unit_name);
            if (value.includes('.') && precision === 0) return prevData;
            if (value.includes('.')) {
              const parts = value.split('.');
              if (parts[1].length > precision) return prevData;
            }
          }

          return updatedData;
        });
      }
    } else {
      flushSync(setData({ ...data, [name]: value }));
    }
  };

  const handleFocus = (e, index, field) => {
    const { name } = e.target;
    const focusAction = refs[name]?.onFocus;
    if (focusAction) focusAction(index, field);
  };

  const handleBlur = (e) => {
    if (document.querySelector('.modal_link') || document.querySelector('.modal_message')) return;
    const { name, value } = e.target;
    const blurAction = refs[name]?.onBlur;
    if (blurAction) blurAction(value, setData);
  };

  const handleKeyDown = (e) => {
    if (document.querySelector('.modal_link') || document.querySelector('.modal_message')) {
      return;
    }
    const { name, value } = e.target;
    // Guard: Ignore events from dynamic inputs (ItemWithGodown modal fields)
    if (!name || !inputRefs[name] || modal_state?.itemwithgodown) {
      // If it's a dynamic field, it should be handled by handleKeyDownItem or useDropdownKeyboardNavigation
      if (e.key === "Enter" || e.key === "Tab") {
        e.preventDefault(); // Prevent form submission
        e.stopPropagation();
      }
      return;
    }

    if (name === "quantity" && (e.key === "Enter" || (e.key === "Tab" && !e.shiftKey))) {
      const unitInfo = parseUnitString(data.unit_name);
      const totalBaseUnits = calculateBaseUnitsFromInput(value, data) || 0;

      if (value !== "" && totalBaseUnits === 0) {
        e.preventDefault();
        setData((prevState) => ({
          ...prevState,
          quantity: "",
          combination_of_units: "",
          rate: "",
          per: "",
          value: "",
          data_item: [{
            id: '1',
            godown_name: '',
            location: '',
            quantity: '',
            combination_of_units: '',
            rate: '',
            id_unit: '',
            per: '',
            value: '',
            total_nos_box: '',
            total_no_box_unit: '',
          }],
          total_quantitiy_allocation: '',
          total_amount_allocation: '',
        }));

        setSubmitConfirm("Accept");
        inputRefs[name]?.current?.blur();
        return;
      }
    }

    if (e.key === "Enter") {
      e.preventDefault();
      let nextField = null;
      const fields = Object.keys(inputRefs);

      if (name === "where_unit") {
        if (parseFloat(value) > 0) {
          nextField = "default_unit_id";
        } else {
          nextField = "where_unit";
        }
      } else if (name === "where_alternate_unit") {
        if (parseFloat(value) > 0) {
          nextField = "where_unit";
        } else {
          nextField = "where_alternate_unit";
        }
      } else if (name === "quantity") {
        const unitInfo = parseUnitString(data.unit_name);
        const mainUnitFactor = unitInfo?.factor || 1;
        const totalBaseUnits = parseTallyQuantity(value?.split(' ')[0], mainUnitFactor, mainUnitFactor > 1) || 0;

        if (value !== "" && totalBaseUnits !== 0 && godown_data.length > 1) {
          dispatch(openModal("itemwithgodown"));
          nextField = null;
        } else {
          if (value) {
            nextField = "rate";
          } else {
            nextField = null;
            setSubmitConfirm("Accept");
            inputRefs[name]?.current?.blur();
          }
        }
      } else if (name === "value") {
        if (value !== "") {
          /*dispatch(openModal("itemwithgodown"));
          setData((prevState) => ({
            ...prevState,
            quantity: "",
            modal_type: "by_vle",
          }));*/
          setSubmitConfirm("Accept");
          inputRefs[name]?.current?.blur();
          nextField = null;
        } else {
          nextField = null;
        }
      } else if (name === "weight") {
        nextField = value === "Available" ? "per_unit" : "quantity";
      } else if (name === "unit_name") {
        nextField = value === "Not Applicable" ? "value" : "alt_unit_name";
        if (value !== "Not Applicable") {
          setData((prevState) => ({
            ...prevState,
            modal_type: "by_qty",
            value: prevState.unit_name === value ? prevState.value : "",
            rate: prevState.unit_name === value ? prevState.rate : "",
            per: prevState.unit_name === value ? prevState.per : "",
          }));
        } else {
          setData((prevState) => ({
            ...prevState,
            modal_type: "by_vle",
            quantity: "",
            rate: "",
            per: "",
          }));
        }
      } else if (name === "alt_unit_name") {
        if (value === "Not Applicable") {
          nextField = "default_unit_id";
        } else {
          nextField = "where_alternate_unit";
        }
        dispatch(closeModal("alt_unit_name"));
      } else if (name === "per_alt_unit") {
        nextField = "quantity";
      } else if (name === "per_unit") {
        nextField =
          data?.alt_unit_name === "Not Applicable"
            ? "quantity"
            : "per_alt_unit";
      } else if (name === "provide_behaviour_opt") {
        nextField =
          data?.provide_behaviour_opt === "Yes"
            ? "ignore_diff_physical"
            : "quantity";
      } else {
        if (name === "inactive_from" && value) {
          let valToParse = value;
          // Handle 6-digit shortcut (112026 -> 1-1-2026)
          if (/^\d{6}$/.test(value.replace(/\D/g, ""))) {
            const d = value.replace(/\D/g, "");
            valToParse = `${d[0]}-${d[1]}-${d.slice(2)}`;
          }

          const dateRes = getInvalidFromDate(valToParse, company_session);
          if (dateRes) {
            // value = dateRes.numericDate; // This value is local, we need to update state if we changed it
            setData((prev) => ({ ...prev, [name]: dateRes.numericDate }));
          } else {
            alert("Invalid date");
            setTimeout(() => {
              inputRefs[name]?.current?.focus();
            }, 0);
            return; // Prevent further navigation
          }
        }
        // Default sequential navigation
        const fields = Object.keys(inputRefs);
        const currentIndex = fields.indexOf(name);
        nextField = fields[currentIndex + 1] || null;
      }

      // Keep looking for next enabled field if current target is disabled or not rendered
      while (nextField && (!inputRefs[nextField]?.current || inputRefs[nextField]?.current?.disabled)) {
        const nextIndex = fields.indexOf(nextField) + 1;
        nextField = fields[nextIndex];
      }
      if (nextField && inputRefs[nextField]?.current && !inputRefs[nextField]?.current?.disabled) {
        inputRefs[nextField].current.focus();
        inputRefs[nextField].current.setSelectionRange(
          0,
          inputRefs[nextField].current.value.length
        );
        if (name === "rate" || name === "per" || name === "value") {
          if (value !== "") {
            const unitInfo = parseUnitString(data.unit_name);
            const mainUnitFactor = unitInfo?.factor || 1;
            const totalBaseUnits = calculateBaseUnitsFromInput(data.quantity, data);
            const quantityLabelForMain = unitInfo?.mainUnit || data?.unit_name || "";
            const precision = getDecimalPlaces(data?.unit_name);
            const formattedQty = formatQuantityWithUnit(totalBaseUnits, mainUnitFactor, quantityLabelForMain, precision, unitInfo);
            const altUnitInfo = parseUnitString(data?.alt_unit_name);
            const altPrecision = getDecimalPlaces(data?.alt_unit_name);
            const totalAltUnits = calculateAltUnits(totalBaseUnits, data);

            let formattedAltQty = "";
            if (altUnitInfo && altUnitInfo.type === 'Compound') {
              formattedAltQty = formatTallyQuantity(totalAltUnits, altUnitInfo.factor, altPrecision, altUnitInfo);
            } else {
              formattedAltQty = formatTallyQuantity(totalAltUnits, 1, altPrecision, altUnitInfo);
            }
            const combination_of_units = (data?.alt_unit_name && data?.alt_unit_name !== "Not Applicable")
              ? `${formattedAltQty}`
              : "";
            const rateNum = parseFloat(removeCurrencyComma(name === "rate" ? value : data.rate)) || 0;
            const perUnit = name === "per" ? value : data.per || "";

            let divisor = 1;
            divisor = calculateUnitsDivisor(data, unitInfo, altUnitInfo, perUnit);

            const calculatedValue = (totalBaseUnits / divisor) * rateNum;

            let updatedDataItems = data.data_item;
            if (godown_data.length === 1) {
              updatedDataItems = data.data_item.map((item, i) => {
                const updatedItem = { ...item };
                updatedItem.quantity = formattedQty;
                updatedItem.rate = currencyFormate(rateNum.toFixed(2));
                updatedItem.per = perUnit;
                updatedItem.value = currencyFormate(calculatedValue.toFixed(2));
                updatedItem.combination_of_units = combination_of_units;
                updatedItem.total_quantitiy_allocation = totalBaseUnits;
                updatedItem.total_amount_allocation = calculatedValue;
                return updatedItem;
              });
            }

            // First update the data state
            setData((prevState) => {
              // Preserve existing godown allocations if they exist and are valid.
              // If there are multiple allocations, keep them, but update the zero-index rate/per defaults if it's currently a placeholder

              return {
                ...prevState,
                quantity: formattedQty,
                value: currencyFormate(calculatedValue.toFixed(2)),
                combination_of_units: combination_of_units,
                total_quantitiy_allocation: totalBaseUnits,
                total_amount_allocation: calculatedValue,
                rate: currencyFormate(rateNum.toFixed(2)),
                per: perUnit,
                data_item: godown_data.length === 1 ? updatedDataItems : data.data_item,
              };
            });
          }
        }
      } else {
        if (name === "quantity") {
          if (value !== "") {
            const unitInfo = parseUnitString(data.unit_name);
            const mainUnitFactor = unitInfo?.factor || 1;
            const isCompound = mainUnitFactor > 1;
            const totalBaseUnits = calculateBaseUnitsFromInput(value, data);
            const quantityLabelForMain = unitInfo?.mainUnit || data?.unit_name || "";
            const precision = getDecimalPlaces(data?.unit_name);
            const formattedQty = formatQuantityWithUnit(totalBaseUnits, mainUnitFactor, quantityLabelForMain, precision, unitInfo);
            const altUnitInfo = parseUnitString(data?.alt_unit_name);
            const mainUnitLabel = unitInfo?.mainUnit || data?.unit_name || "";
            const altUnitLabel = altUnitInfo?.mainUnit || data?.alt_unit_name || "";
            const altPrecision = getDecimalPlaces(data?.alt_unit_name);
            const totalAltUnits = calculateAltUnits(totalBaseUnits, data);

            let formattedAltQty = "";
            if (altUnitInfo && altUnitInfo.type === 'Compound') {
              formattedAltQty = formatTallyQuantity(totalAltUnits, altUnitInfo.factor, altPrecision, altUnitInfo);
            } else {
              formattedAltQty = formatTallyQuantity(totalAltUnits, 1, altPrecision, altUnitInfo);
            }
            const combination_of_units = (data?.alt_unit_name && data?.alt_unit_name !== "Not Applicable")
              ? `${formattedAltQty}`
              : "";

            const rateNum = parseFloat(removeCurrencyComma(data.rate)) || 0;
            const perUnit = data.per || "";

            let divisor = 1;
            divisor = calculateUnitsDivisor(data, unitInfo, altUnitInfo, perUnit);

            const calculatedValue = (totalBaseUnits / divisor) * rateNum;

            // First update the data state
            setData((prevState) => {
              // Preserve existing godown allocations if they exist and are valid.
              // If there are multiple allocations, keep them, but update the zero-index rate/per defaults if it's currently a placeholder
              const hasActualAllocations = prevState.data_item?.length > 1 || (prevState.data_item?.length === 1 && prevState.data_item[0]?.godown_name !== '' && prevState.data_item[0]?.per !== '' && prevState.data_item[0]?.rate !== '' && prevState.data_item[0]?.value !== '');

              let newDataItems = prevState.data_item;
              if (totalBaseUnits === 0) {
                newDataItems = [];
              } else if (!hasActualAllocations) {
                newDataItems = [
                  {
                    godown_name: godown_data[0]?.name || "",
                    quantity: formattedQty,
                    rate: currencyFormate(rateNum.toFixed(2)),
                    per: prevState?.per || mainUnitLabel,
                    value: currencyFormate(calculatedValue.toFixed(2)),
                    combination_of_units: combination_of_units
                  }
                ];
              }

              return {
                ...prevState,
                quantity: formattedQty,
                value: currencyFormate(calculatedValue.toFixed(2)),
                combination_of_units: combination_of_units,
                total_quantitiy_allocation: totalBaseUnits,
                total_amount_allocation: calculatedValue,
                data_item: newDataItems,
                rate: currencyFormate(rateNum.toFixed(2)),
                per: perUnit
              };
            });

            if (totalBaseUnits !== 0) {
              setTimeout(() => {
                dynamicInputRef?.current["godown_name0 "]?.focus();
              }, 50);
            }
          }
        } else if (name === "value") {
          if (value !== "" && godown_data?.length > 1) {
            setTimeout(() => {
              dynamicInputRef?.current["godown_name0 "]?.focus();
            }, 50);
          } else if (!value) {
            setSubmitConfirm("Accept");
            inputRefs[name]?.current?.blur();
          }
        } else {
          setSubmitConfirm("Accept");
          inputRefs[name]?.current?.blur();
        }
      }
      return;
    }

    // Handle Shift+Tab for previous input focus
    if (e.shiftKey && e.key === "Tab") {
      e.preventDefault();
      const fields = Object.keys(inputRefs);
      const currentIndex = fields.indexOf(name);

      // Get the previous field
      const prevField = fields[currentIndex - 1];

      // Special cases for field navigation based on values and conditions
      let targetField = prevField;

      if (name === "quantity") {
        if (data?.alt_unit_name !== "Not Applicable") {
          targetField = "per_alt_unit";
        } else {
          targetField = "per_unit";
        }
      } else if (name === "per_alt_unit") {
        targetField = "per_unit";
      } else if (name === "where_alternate_unit") {
        if (data?.alt_unit_name !== "Not Applicable") {
          targetField = "alt_unit_name";
        }
      } else if (name === "where_unit") {
        if (data?.alt_unit_name !== "Not Applicable") {
          targetField = "where_alternate_unit";
        }
      } else if (name === "default_unit_id") {
        if (parseFloat(data?.where_unit) > 0) {
          targetField = "where_unit";
        } else {
          targetField = "where_alternate_unit";
        }
      } else if (name === "value") {
        if (data?.unit_name === "Not Applicable") {
          targetField = "unit_name";
        } else {
          targetField = "per";
        }
      } else if (name === "per") {
        targetField = "rate";
      } else if (name === "rate") {
        targetField = "quantity";
      }

      // Keep looking for previous enabled field if current target is disabled or not rendered
      while (targetField && (!inputRefs[targetField]?.current || inputRefs[targetField]?.current?.disabled)) {
        const prevIndex = fields.indexOf(targetField) - 1;
        targetField = fields[prevIndex];
      }

      // Focus on previous input if it exists and is not disabled
      if (
        targetField &&
        inputRefs[targetField]?.current &&
        !inputRefs[targetField]?.current?.disabled
      ) {
        inputRefs[targetField].current.focus();
        inputRefs[targetField].current.setSelectionRange(
          0,
          inputRefs[targetField].current.value.length
        );
      }
    }
  };

  const handleDropdownClick = (name, value) => {
    setData((prevState) => {
      const updatedData = { ...prevState, [name]: value };
      if (name === "unit_name") {
        const unitInfo = parseUnitString(value);
        if (unitInfo && unitInfo.type === 'Compound') {
          updatedData.where_unit = prevState.where_unit || 1;
          updatedData.where_alternate_unit = prevState.where_alternate_unit || unitInfo.factor;
          updatedData.where_unit_name = unitInfo.mainUnit;
          updatedData.where_alternate_unit_name = unitInfo.baseUnit;
          updatedData.per = unitInfo.mainUnit;
        } else if (unitInfo) {
          updatedData.where_unit = prevState.where_unit || 0;
          updatedData.where_alternate_unit = prevState.where_alternate_unit || 0;
          updatedData.where_unit_name = unitInfo.mainUnit;
          updatedData.where_alternate_unit_name = '';
          updatedData.per = unitInfo.mainUnit;
        }

        if (value !== "Not Applicable") {
          updatedData.modal_type = "by_qty";
          updatedData.value = prevState?.unit_name === value ? prevState?.value : "";
          updatedData.rate = prevState?.unit_name === value ? prevState?.rate : "";
          updatedData.per = prevState?.unit_name === value ? prevState?.per : "";
        } else {
          updatedData.modal_type = "by_vle";
          updatedData.quantity = "";
          updatedData.rate = "";
          updatedData.per = "";
        }
      }

      if (name === "alt_unit_name") {
        if (value === "Not Applicable") {
          updatedData.default_unit_id = "Not Applicable";
          updatedData.default_unit_rate = "Not Applicable";
        }
      }

      if (name === "per") {
        if (value !== "") {
          const unitInfo = parseUnitString(prevState.unit_name);
          const totalBaseUnits = calculateBaseUnitsFromInput(prevState.quantity, prevState);
          const altUnitInfo = parseUnitString(prevState?.alt_unit_name);
          const rateNum = parseFloat(removeCurrencyComma(name === "rate" ? value : prevState.rate)) || 0;
          const perUnit = name === "per" ? value : prevState.per || "";

          let divisor = 1;
          divisor = calculateUnitsDivisor(prevState, unitInfo, altUnitInfo, perUnit);

          const calculatedValue = (totalBaseUnits / divisor) * rateNum;
          updatedData.value = currencyFormate(calculatedValue.toFixed(2));
        }
      }

      return updatedData;
    });

    // Programmatic focus movement
    setTimeout(() => {
      let nextField = null;
      const fields = Object.keys(inputRefs);
      if (name === "under_id") {
        nextField = "stock_cat";
      } else if (name === "stock_cat") {
        nextField = "stock_company";
      } else if (name === "stock_company") {
        nextField = "unit_name";
      } else if (name === "unit_name") {
        nextField = value === "Not Applicable" ? "value" : "alt_unit_name";
      } else if (name === "alt_unit_name") {
        nextField = value === "Not Applicable" ? "default_unit_id" : "where_alternate_unit";
      } else if (name === "default_unit_id") {
        nextField = "default_unit_rate";
      } else if (name === "default_unit_rate") {
        nextField = "weight";
      } else if (name === "weight") {
        nextField = value === "Available" ? "per_unit" : "quantity";
      } else if (name === "provide_behaviour_opt") {
        nextField = value === "Yes" ? "ignore_diff_physical" : "quantity";
      } else if (name === "GST_applicable") {
        nextField = value === "Applicable" ? "HSN_SAC_details" : "type_of_supply";
      } else if (name === "HSN_SAC_details" || name === "GST_rate_details") {
        nextField = "type_of_supply"; // Default jump if not specified
      }

      // Keep looking for next enabled field if current target is disabled or not rendered
      while (nextField && (!inputRefs[nextField]?.current || inputRefs[nextField]?.current?.disabled)) {
        const nextIndex = fields.indexOf(nextField) + 1;
        nextField = fields[nextIndex];
      }
      if (nextField && inputRefs[nextField]?.current && !inputRefs[nextField]?.current?.disabled) {
        inputRefs[nextField].current.focus();
        if (inputRefs[nextField].current.setSelectionRange) {
          inputRefs[nextField].current.setSelectionRange(0, inputRefs[nextField].current.value?.length || 0);
        }
      }
    }, 100);
  };

  const itemDropdownCalculationHandler = (index, key, value) => {
    setData((prevState) => {
      const unitInfo = parseUnitString(prevState.unit_name);
      const mainUnitFactor = unitInfo?.factor || 1;
      const isCompound = mainUnitFactor > 1;

      const updatedDataItems = prevState.data_item.map((item, i) => {
        if (i === index) {
          const updatedItem = { ...item, [key]: value };

          // Calculation logic
          const totalBaseUnits = calculateBaseUnitsFromInput(updatedItem.quantity, prevState);
          const rateNum = parseFloat(removeCurrencyComma(updatedItem.rate)) || 0;
          const perUnit = updatedItem.per || "";

          let divisor = 1;
          const altUnitInfo = parseUnitString(prevState.alt_unit_name);
          divisor = calculateUnitsDivisor(prevState, unitInfo, altUnitInfo, perUnit);

          const totalAltUnits = calculateAltUnits(totalBaseUnits, prevState);
          const altPrecision = getDecimalPlaces(prevState?.alt_unit_name);

          let formattedAltQty = "";
          if (altUnitInfo && altUnitInfo.type === 'Compound') {
            formattedAltQty = formatTallyQuantity(totalAltUnits, altUnitInfo.factor, altPrecision, altUnitInfo);
          } else {
            formattedAltQty = formatTallyQuantity(totalAltUnits, 1, altPrecision, altUnitInfo);
          }

          updatedItem.combination_of_units = (prevState?.alt_unit_name && prevState?.alt_unit_name !== "Not Applicable")
            ? `${formattedAltQty}`
            : "";
          updatedItem.value = currencyFormate(((totalBaseUnits / divisor) * rateNum).toFixed(2));
          return updatedItem;
        }
        return item;
      });

      const totalQuantity = updatedDataItems.reduce((sum, item) => {
        return sum + (calculateBaseUnitsFromInput(item.quantity, prevState) || 0);
      }, 0);


      const totalAmount = updatedDataItems.reduce((sum, item) => {
        return sum + (parseFloat(removeCurrencyComma(item.value)) || 0);
      }, 0);

      return {
        ...prevState,
        data_item: updatedDataItems,
        total_quantitiy_allocation: totalQuantity,
        total_amount_allocation: totalAmount,
      };
    });

    // Close dropdown and focus next field
    const refKey = `${key}${index} `;
    dispatch(closeModal(refKey));

    setTimeout(() => {
      const fields = ["godown_name", "quantity", "rate", "per", "value"];
      const nextFieldKey = fields[fields.indexOf(key) + 1] || "godown_name";
      const nextRef = dynamicInputRef.current[`${nextFieldKey}${index} `];
      if (nextRef) {
        nextRef.focus();
        nextRef.setSelectionRange(0, nextRef.value?.length || 0);
      }
    }, 100);
  };

  return {
    data,
    setData,
    handleChange,
    handleFocus,
    handleBlur,
    handleKeyDown,
    submitConfirm,
    setSubmitConfirm,
    handleItemUpdate,
    handleKeyDownItem,
    handleDynamicFocus,
    handleDynamicBlur,
    handleDropdownClick,
    handleItemDropdownClick: itemDropdownCalculationHandler,
    getDecimalPlaces,
  };
};
